import React from 'react';
import { GripVertical } from 'lucide-react';
import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

interface DragHandleProps {
  provided?: {
    dragHandleProps?: Record<string, unknown> | null;
  } | null;
  attributes?: DraggableAttributes | null;
  listeners?: SyntheticListenerMap | null;
}

export const DragHandle: React.FC<DragHandleProps> = ({ provided, attributes, listeners }) => {
  // Don't render drag handle if no drag props are available (for temporary todos)
  if (!provided?.dragHandleProps && !listeners) {
    return (
      <div style={{ 
        opacity: 0.3, 
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'grab',
        padding: '4px',
        color: 'var(--app-text-muted)'
      }}>
        <GripVertical size={18} />
      </div>
    );
  }
  
  // Use either the old provided format or new attributes/listeners format
  const dragProps = provided?.dragHandleProps ? 
    provided.dragHandleProps : 
    { ...attributes, ...listeners };
  
  return (
    <div
      {...dragProps}
      style={{ 
        // Allow vertical scrolling when the user swipes on/near the handle.
        // DnD will still prevent scrolling once a drag is actually activated.
        touchAction: 'pan-y',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'grab',
        padding: '4px',
        color: 'var(--app-text-muted)',
        transition: 'color 0.2s ease'
      }}
      aria-label="Drag to reorder"
      onMouseEnter={(e) => e.currentTarget.style.color = 'var(--app-text-primary)'}
      onMouseLeave={(e) => e.currentTarget.style.color = 'var(--app-text-muted)'}
    >
      <GripVertical size={18} />
    </div>
  );
};

export default DragHandle;
